import Api from "@/api/Api";

class OrganizationApi extends Api {
  url = `${process.env.VUE_APP_XHR_ROOT}/disclosurecode/private/`;

  public getList(organizationId?: string | number, data?: object): any {
    const url = this.prepareUrl("organization/", organizationId);
    return this.requestGetList(url, data, "results");
  }

  public get(id: number): any {
    const url = this.prepareUrl(`organization/${id}`);
    return this.requestGet(url);
  }

  public remove(id: number): any {
    const url = this.prepareUrl(`organization/${id}`);
    return this.requestDelete(url);
  }

  public getOrganizationUrl(organizationId?: number): any {
    const url =
      `${this.url}organization/` +
      (organizationId && !isNaN(organizationId) ? organizationId : "");

    return url;
  }
}

export default new OrganizationApi();
